import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
  CreateResourceString,
  GetResourceStringsRequest,
  GetResourceStringsResponse,
  ResourceString
} from '../../models/resource-string.models';

@Injectable({
  providedIn: 'root'
})
export class ResourceStringService {
  private api = `${environment.baseV5ApiUri}/ResourceString`;

  constructor(private http: HttpClient) {}

  private buildParams(request: GetResourceStringsRequest): HttpParams {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(request)) {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, value.toString());
      }
    }
    return params;
  }

  getAllFrontEnd(): Observable<GetResourceStringsResponse> {
    const request: GetResourceStringsRequest = {
      label: 'FrontEnd',
      pageIndex: 0,
      pageSize: 10000,
      ascending: true
    };

    const params = this.buildParams(request);
    return this.http.get<GetResourceStringsResponse>(`${this.api}`, { params });
  }

  getPage(request: GetResourceStringsRequest): Observable<GetResourceStringsResponse> {
    const params = this.buildParams(request);
    return this.http.get<GetResourceStringsResponse>(`${this.api}`, { params });
  }

  getById(id: string): Observable<ResourceString> {
    return this.http.get<ResourceString>(`${this.api}/${id}`);
  }

  create(request: CreateResourceString): Observable<void> {
    return this.http.post<void>(`${this.api}`, request).pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  update(id: string, request: CreateResourceString): Observable<void> {
    return this.http.put<void>(`${this.api}/${id}`, request).pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.api}/${id}`).pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  bulkDelete(ids: string[]): Observable<void> {
    return this.http.delete<void>(`${this.api}/bulk-delete`, { body: ids }).pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  export(ids: string[]): Observable<{ resourceStrings: ResourceString[] }> {
    return this.http
      .post<{ resourceStrings: ResourceString[] }>(`${this.api}/export`, ids)
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      );
  }

  validateImport(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('json', file);
    return this.http.post<any>(`${this.api}/validate-import`, formData).pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  import(request: { key: string; names: string[] }): Observable<string[]> {
    return this.http.post<string[]>(`${this.api}/import`, request).pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }
}
